import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/Auth.css';
import { api } from "../api"; 

const RegistroResponsavel = () => {
  const [modoSolicitar, setModoSolicitar] = useState(false);
  const [formData, setFormData] = useState({
    cpf: '',
    nome: '',
    email: '',
    telefone: '',
    senha: '',
    confirmarSenha: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const formatCPF = (cpf) => {
    const numbers = cpf.replace(/\D/g, '');
    return numbers.slice(0, 11);
  };

  const handleCPFChange = (e) => {
    const formatted = formatCPF(e.target.value);
    setFormData((prev) => ({ ...prev, cpf: formatted }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    // Validações
    if (formData.senha !== formData.confirmarSenha) {
      setError('As senhas não coincidem');
      setLoading(false);
      return;
    }

    if (formData.senha.length < 8) {
      setError('A senha deve ter no mínimo 8 caracteres');
      setLoading(false);
      return;
    }

    if (formData.cpf.length !== 11) {
      setError('CPF deve ter 11 dígitos');
      setLoading(false);
      return;
    }

    try {
      const endpoint = modoSolicitar 
        ? '/api/responsaveis/solicitar-senha'
        : '/api/responsaveis/cadastro';

      
      const body = modoSolicitar
        ? { cpf: formData.cpf }
        : {
            cpf: formData.cpf,
            nome_completo: formData.nome,
            email: formData.email,
            telefone: formData.telefone,
            senha: formData.senha,
            confirmar_senha: formData.confirmarSenha,
          };

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || 'Erro ao processar solicitação');
      }

      if (modoSolicitar) {
        const senhaTempMsg = data.senha_temporaria
          ? ` Senha temporária: ${data.senha_temporaria}.`
          : '';
        setSuccess(
          `Senha temporária enviada para ${data.email}. Verifique seu e-mail e faça login.${senhaTempMsg} Redirecionando...`
        );
      } else {
        setSuccess(
          `Cadastro realizado com sucesso! ${data.alunos_vinculados || 0} filho(s) vinculado(s). Redirecionando para login...`
        );
      }

      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>{modoSolicitar ? 'Solicitar Senha' : 'Cadastro de Responsável'}</h1>
          <p>
            {modoSolicitar 
              ? 'Digite seu CPF para receber uma senha temporária por e-mail' 
              : 'Crie sua conta para acompanhar os dados dos seus filhos'}
          </p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
          <button
            type="button"
            onClick={() => {
              setModoSolicitar(!modoSolicitar);
              setError('');
              setSuccess('');
            }}
            style={{
              background: 'none',
              border: 'none',
              color: '#1890ff',
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: '14px'
            }}
          >
            {modoSolicitar 
              ? '← Voltar para cadastro novo' 
              : 'Já tenho cadastro - Solicitar senha'}
          </button>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="cpf">CPF *</label>
            <input
              type="text"
              id="cpf"
              name="cpf"
              value={formData.cpf}
              onChange={handleCPFChange}
              placeholder="Digite apenas números (11 dígitos)"
              required
              disabled={loading}
              maxLength={11}
            />
            <small style={{ color: 'var(--text-secondary)', fontSize: '12px' }}>
              {modoSolicitar 
                ? 'Digite o CPF que você usou no cadastro' 
                : 'Use o CPF cadastrado como responsável financeiro, mãe ou pai do aluno'}
            </small>
          </div>

          {!modoSolicitar && (
            <>
              <div className="form-group">
                <label htmlFor="nome">Nome Completo *</label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  placeholder="Seu nome completo"
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="seu@email.com"
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="telefone">Telefone</label>
                <input
                  type="tel"
                  id="telefone"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  placeholder="(00) 00000-0000"
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="senha">Senha *</label>
                <div className="password-input-group">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="senha"
                    name="senha"
                    value={formData.senha}
                    onChange={handleChange}
                    placeholder="Mínimo 6 caracteres"
                    required
                    disabled={loading}
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={loading}
                  >
                    {showPassword ? '👁️' : '👁️‍🗨️'}
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="confirmarSenha">Confirmar Senha *</label>
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="confirmarSenha"
                  name="confirmarSenha"
                  value={formData.confirmarSenha}
                  onChange={handleChange}
                  placeholder="Digite a senha novamente"
                  required
                  disabled={loading}
                />
              </div>
            </>
          )}

          <button type="submit" className="btn btn-primary" disabled={loading || success}>
            {loading 
              ? (modoSolicitar ? 'Enviando...' : 'Cadastrando...') 
              : (modoSolicitar ? 'Enviar Senha por E-mail' : 'Cadastrar')}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/login" className="link">
            Voltar para Login
          </Link>
        </div>

        <div className="auth-footer">
          <p>© 2026 Fisicore. Todos os direitos reservados.</p>
        </div>
      </div>
    </div>
  );
};

export default RegistroResponsavel;
